var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 34.167,
    height: 34.167,
    viewBox: "0 0 34.167 34.167",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "technical-support",
    transform: "translate(0.25 0.25)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_34627",
    "data-name": "Group 34627",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_65344",
    "data-name": "Path 65344",
    d: "M31.345,372.172H2.322A2.324,2.324,0,0,1,0,369.85v-4.243a.863.863,0,0,1,.863-.863H11.716a.863.863,0,0,1,.8.541l.657,1.629h7.3l.657-1.629a.863.863,0,0,1,.8-.541H32.8a.863.863,0,0,1,.863.863v4.243a2.324,2.324,0,0,1-2.322,2.322Zm-29.619-5.7v3.38a.6.6,0,0,0,.6.6H31.345a.6.6,0,0,0,.6-.6v-3.38H22.518l-.657,1.629a.863.863,0,0,1-.8.541h-8.47a.863.863,0,0,1-.8-.541l-.657-1.629Z",
    transform: "translate(0 -338.505)",
    fill: "#06233d",
    stroke: "#fff",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65345",
    "data-name": "Path 65345",
    d: "M58.81,9.788H56.347V7.939a.841.841,0,0,0-.661-.812L54.1,6.759a7.374,7.374,0,0,0-.3-.7l.845-1.325A.814.814,0,0,0,54.513,3.7L52.466,1.754a.886.886,0,0,0-1.049-.122l-1.4.81q-.367-.167-.75-.3L48.879.634A.858.858,0,0,0,48.041,0H45.146a.858.858,0,0,0-.838.634l-.386,1.5q-.383.129-.751.3l-1.407-.813a.885.885,0,0,0-1.049.122L38.669,3.69a.814.814,0,0,0-.129,1.033l.841,1.319a7.4,7.4,0,0,0-.3.7l-1.594.371a.841.841,0,0,0-.661.812V9.788H34.359a2.268,2.268,0,0,0-2.3,2.226V25.4a.864.864,0,0,0,1.727,0V12.014a.567.567,0,0,1,.576-.557H58.81a.567.567,0,0,1,.576.557V25.4a.864.864,0,0,0,1.727,0V12.014A2.268,2.268,0,0,0,58.81,9.788ZM44.394,9.309a2.192,2.192,0,0,1,4.381,0,2.057,2.057,0,0,1-.056.479H44.45A2.061,2.061,0,0,1,44.394,9.309Zm10.227.479H50.47a3.714,3.714,0,0,0,.032-.479,3.919,3.919,0,0,0-7.834,0,3.726,3.726,0,0,0,.032.479H38.548V8.579l1.4-.326a.851.851,0,0,0,.627-.578,5.745,5.745,0,0,1,.549-1.254.811.811,0,0,0-.016-.85l-.738-1.157,1.081-1.029,1.242.718a.889.889,0,0,0,.857.016A6.4,6.4,0,0,1,44.876,3.6a.848.848,0,0,0,.606-.6l.34-1.324h1.545L47.707,3a.848.848,0,0,0,.6.6,6.4,6.4,0,0,1,1.323.525.889.889,0,0,0,.859-.015L51.73,3.4l1.081,1.029-.741,1.162a.811.811,0,0,0-.017.848A5.745,5.745,0,0,1,52.6,7.691a.851.851,0,0,0,.628.581L54.62,8.6Z",
    transform: "translate(-29.751 0)",
    fill: "#06233d",
    stroke: "#fff",
    strokeWidth: 0.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_34628",
    "data-name": "Group 34628",
    transform: "translate(8.547 15.233)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_65346",
    "data-name": "Path 65346",
    d: "M118.81,231.5l5.247,2.7v-1.656l-3.138-1.573,3.138-1.573v-1.656l-5.247,2.7Z",
    transform: "translate(-118.81 -226.593)",
    fill: "#06233d",
    stroke: "#fff",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65347",
    "data-name": "Path 65347",
    d: "M204.486,219.452h1.585l2.973-7.7h-1.6Z",
    transform: "translate(-198.323 -211.755)",
    fill: "#06233d",
    stroke: "#fff",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65348",
    "data-name": "Path 65348",
    d: "M276.248,227.763v1.655l3.16,1.572-3.16,1.572v1.655l5.247-2.691v-1.072Z",
    transform: "translate(-264.922 -226.611)",
    fill: "#06233d",
    stroke: "#fff",
    strokeWidth: 0.5
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIt);
export default __webpack_public_path__ + "static/media/it.6a9e16ed8b4e2ae25e58d157c94ba9cb.svg";
export { ForwardRef as ReactComponent };